import { ChangeDetectionStrategy, Component, inject, model, signal, Signal } from '@angular/core';
import { Button } from 'primeng/button';
import { Drawer } from 'primeng/drawer';
import { FormGroup, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormFactoryService } from '../../services/utility/form-factory.service';
import { AbstractToggleSidePanelComponent } from '../abstract-toggle-side-panel/abstract-toggle-side-panel';
import { AsyncApiService } from '@spike/core';
import { EntityApiEnum } from 'src/app/config/entity-api.enum';
import { AccountTransfer } from '../../models/account-transfer';
import { AccountTransferFormComponent } from '../../forms/account-transfer-form/account-transfer-form';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-account-transfer-side-panel',
  providers:[],
  imports: [CommonModule, FormsModule, Button, Drawer, AccountTransferFormComponent],
  templateUrl: './account-transfer-side-panel.html'
})
export class AccountTransferSidePanelComponent extends AbstractToggleSidePanelComponent<AccountTransfer>{
  private readonly formFactory = inject(FormFactoryService);
  private readonly asyncApi = inject(AsyncApiService);
  private readonly tradeApiEnum = EntityApiEnum.FIN_TRADE;

  override disabledFields: Signal<string[]> = signal([]);

  protected override buildFormArrays(data: AccountTransfer): void {
    
  }

  public readonly form: FormGroup<any> =this.formFactory.createAccountTransferForm();
  public readonly data = signal<AccountTransfer>({} as AccountTransfer);

  async onSaveClicked() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      const rawValue = this.form.getRawValue() as AccountTransfer;
      const tradeToSave : AccountTransfer = await this.asyncApi.call(this.tradeApiEnum, 'account-transfer/insert', rawValue);
      this.onSave.emit(tradeToSave);
      this.data.set(tradeToSave);
      this.isDialogVisible.set(false)
    }
  }

}